import { render, staticRenderFns } from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=template&id=7d7ebb2c&scoped=true"
import script from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7ebb2c",
  null
  
)

export default component.exports